(function () {
  'use strict';

  function replaceHg(url, hardness) {
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('hg', hardness);
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (error) {
      return url;
    }
  }

  function recommendationFor(weight, isLatex) {
    if (isLatex) {
      return weight === 'w100p'
        ? { code: 'fest', label: 'Festigkeit Fest' }
        : { code: 'mittel', label: 'Festigkeit Mittel' };
    }

    if (weight === 'w100p') {
      return { code: 'h4', label: 'Härtegrad 4 (fest)' };
    }

    if (weight === 'w8090' || weight === 'w90100') {
      return { code: 'h3', label: 'Härtegrad 3 (mittel)' };
    }

    return { code: 'h2', label: 'Härtegrad 2 (weich)' };
  }

  function setText(element, value) {
    if (element && element.textContent !== value) {
      element.textContent = value;
    }
  }

  function setHref(element, value) {
    if (!element || !value) return;
    var current = element.getAttribute('href') || '';
    if (current !== value) {
      element.setAttribute('href', value);
    }
  }

  function isLatexRecommendation(container) {
    var productName = container.querySelector('.bu-finder__duo-product, [data-bu-result-title]');
    return Boolean(productName && /naturlatex/i.test(productName.textContent));
  }

  function personIndexFrom(button) {
    var step = button.closest('[data-bu-step]');
    var progress = step && step.querySelector('.bu-finder__progress');
    return progress && /Person\s*2/i.test(progress.textContent) ? 1 : 0;
  }

  function enhance(root) {
    if (!root || root.dataset.bettupConsistencyReady === 'true') return;
    root.dataset.bettupConsistencyReady = 'true';

    var labels = {
      w70: 'Bis 69 kg',
      w7080: '70–79 kg',
      w8090: '80–89 kg',
      w90100: '90–99 kg',
      w100p: '100–120 kg'
    };

    root.querySelectorAll('[data-bu-answer="weight"]').forEach(function (button) {
      var title = button.querySelector('.bu-finder__option-title');
      var label = labels[button.dataset.buValue];
      if (title && label) title.textContent = label;
    });

    var weights = [];

    function enforce() {
      var result = root.querySelector('[data-bu-step="result"]');
      if (!result || result.hidden || !weights[0]) return;

      var duoCards = result.querySelectorAll('.bu-finder__duo-card');
      if (duoCards.length) {
        duoCards.forEach(function (card, index) {
          var recommendation = recommendationFor(
            weights[index] || weights[0],
            isLatexRecommendation(card)
          );
          var grade = card.querySelector('p strong');
          var link = card.querySelector('[data-bu-result-link]');
          setText(grade, recommendation.label);
          if (link) setHref(link, replaceHg(link.href, recommendation.code));
        });
        return;
      }

      var recommendation = recommendationFor(weights[0], isLatexRecommendation(result));
      var grade = result.querySelector('[data-bu-result-grade]');
      var link = result.querySelector('[data-bu-result-link]');
      setText(grade, recommendation.label);
      if (link) setHref(link, replaceHg(link.href, recommendation.code));

      var hint = result.querySelector('[data-bu-result-hint]');
      if (hint && hint.hidden) {
        hint.textContent = 'Die Härtegrad-Vorauswahl folgt dem veröffentlichten Gewichtsbereich. Persönliches Liegegefühl und Körperbau können davon abweichen.';
        hint.hidden = false;
      }
    }

    root.addEventListener('click', function (event) {
      var restart = event.target.closest('[data-bu-restart]');
      var who = event.target.closest('[data-bu-answer="who"]');
      var weightButton = event.target.closest('[data-bu-answer="weight"]');
      var answerButton = event.target.closest('[data-bu-answer]');

      if (restart || who) {
        weights = [];
      }

      if (weightButton) {
        weights[personIndexFrom(weightButton)] = weightButton.dataset.buValue;
      }

      if (answerButton) {
        window.setTimeout(enforce, 0);
      }
    });
  }

  function scan(scope) {
    (scope || document).querySelectorAll('.bu-finder').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    }, { once: true });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
